import { render, staticRenderFns } from "./CalcIssueFareRegisReqPop.vue?vue&type=template&id=4c10406d&scoped=true"
import script from "./CalcIssueFareRegisReqPop.vue?vue&type=script&lang=js"
export * from "./CalcIssueFareRegisReqPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10406d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c10406d')) {
      api.createRecord('4c10406d', component.options)
    } else {
      api.reload('4c10406d', component.options)
    }
    module.hot.accept("./CalcIssueFareRegisReqPop.vue?vue&type=template&id=4c10406d&scoped=true", function () {
      api.rerender('4c10406d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CalcIssueFareRegisReqPop.vue"
export default component.exports